import React from 'react'
import { Container, Row, Col } from "react-bootstrap";

const Experience = () => {
  return (
    <>
        <Container className="" id="about">
            <Row>
                <Col md={12} style={{marginBottom: '2rem'}}>
                    <h1 style={{ display: 'flex', justifyContent: 'space-between'}}>
                        <span className="yellow"> Trademarkia</span>
                    </h1>
                    <h3 style={{ display: 'flex', justifyContent: 'flex-start' }}><b className='yellow'>Frontend&nbsp;</b> Developer Intern</h3>
                    <h5 style={{ display: 'flex', justifyContent: 'flex-start' }}>Jan 2025 – Present | Hyderabad, Telangana</h5>
                    <p className="home-about-body">
                    <ul style={{listStyle: 'none', marginTop: '-1rem'}}>
                        <li>Optimized SEO and performance by implementing server-side rendering for inital fetch and client side on <b className='yellow'>infinite scrolling</b>.</li>
                        <li> Implemented an intuitive <b className='yellow'>email search functionality</b> and single mail view, enhancing user accessibility.</li>
                        <li>Implemented <b className='yellow'>localization with react-i18n</b>, enabling seamless multi-language support.</li>
                        <li>Built <b className='yellow'>secure authentication middleware</b>, implemented <b className='yellow'>data validation with Joi</b>, and optimized database structures using PostgreSQL.</li>
                        <li>Collaborated on designing the database schema and <b className='yellow'>developed all routes and backend functionality for polls feature.</b></li>
                        <li>Integrated <b className='yellow'>Firebase</b> authentication and storage, improving file handling and user onboarding.</li>
                    </ul>
                    </p>
                </Col>
            </Row>
        </Container>
    </>
  )
}

export default Experience